import React from "react";

export default function E404() {
    return (
        <h1>404</h1>
    )
}